import { useState, useEffect } from 'react';
import { useSidebar } from '../SidebarContext';
import ImageUploader from './ImageUploader';
import GalleryModal from './GalleryModal';

const Gallery = () => {
    const [gallery, setGallery] = useState([
        {
            title: 'Project A',
            description: 'Website Development Project',
            featuredImage: 'image1.jpg',
            previewLink: 'https://example.com/project-a',
        },
        {
            title: 'Project B',
            description: 'Marketing Campaign Design',
            featuredImage: 'image2.jpg',
            previewLink: 'https://example.com/project-b',
        },
    ]);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');

    const [filteredGallery, setFilteredGallery] = useState(gallery);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = gallery.filter((item) =>
            Object.values(item).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredGallery(filtered);
        setCurrentPage(1);
    }, [searchQuery, gallery]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredGallery.length / itemsPerPage);
    const currentData = filteredGallery.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = (indexToDelete) => {
        const updatedGallery = gallery.filter((_, index) => index !== indexToDelete);
        setGallery(updatedGallery);
    };

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Gallery</h1>

                <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                    Add Gallery
                </button>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i>
                </div>
            </div>

            {/* Gallery Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Featured Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.title}</td>
                                    <td>{item.description}</td>
                                    <td>
                                        <img
                                            src={item.featuredImage}
                                            alt="Featured"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                borderRadius: "5px"
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <button className="edit-btn" onClick={() => setIsModalOpen(true)}>
                                            <i className="fa-solid fa-pen"></i>
                                        </button>
                                        <button className="delete-btn" onClick={() => handleDelete(index)}>
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            )}

            <GalleryModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />

        </>
    );
};

export default Gallery;
